import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Cranach Design ist ein Design System für digtiale Produkte und Tools des Cranach Digital Archives. Dieses System besteht aktuell aus vordefinierte Developer-Ressourcen, Richtlinen und Dokumentationen. Dieses Design System ist ein Prototyp und wird aktuell zu Test-Zwecken zur Verfügung gestellt.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{` Prototyp `}</strong>{` Dieses Cranach Design System ist nicht vollständig und wird aktuell zu Test-Zwecke zur Verfügung gestellt.`}</p>
    </InlineNotification>
    <h2>{`Willkommen`}</h2>
    <p>{`Das Cranach Design System ist aus Bearbeitung einer Masterarbeit entstanden und ist aktuell ein Prototyp. Das Cranach Design soll Designer und Entwickler dabei unterstützen, qualitative und konsistente UI zu entwickeln. Mit der Integration des Cranach Designs soll die effizienz während dem Design/der Entwicklung erhöht werden, in dem vordefinierte Lösungen genutzt werden und die Beteiligten sich auf den Design- und Entwicklungsprozess fokussieren können. Das Design System soll dabei alle Fragen bezüglich des Cranach Designs beantworten.`}</p>
    <p>{`Das `}<a parentName="p" {...{
        "href": "https://lucascranach.org"
      }}>{`Cranach Digital Archive (cda)`}</a>{` ist ein Forschungsprojekt zur digitalen Erschließung der Gemälde eines der bedeutendsten Maler der deutschen Renaissance: Lucas Cranach der Ältere. An diesem Forschungsprojekt arbeiten der Kunspalast in Düsseldorf und die Technische Hochschule Köln im Verbund mit 310 Patnern in 31 Ländern. Die ausgewerteten Gemälde werden von einem Team als digtale Ressource zur Verfügung gestellt.`}</p>
    <p>{`Das Design System wurde in `}<a parentName="p" {...{
        "href": "gatsby.js"
      }}>{`GatsbyJS`}</a>{` und `}<a parentName="p" {...{
        "href": "https://reactjs.org"
      }}>{`React`}</a>{` entwickelt. Dieses Design System leitet sich von IBM’s `}<a parentName="p" {...{
        "href": "https://www.carbondesignsystem.com"
      }}>{`Carbon Design System`}</a>{` ab, das `}<a parentName="p" {...{
        "href": "https://www.ibm.com/de-de"
      }}>{`IBM`}</a>{` ebenfalls als Vorlage bereitstellt.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      